<script setup></script>

<template>
  <div class="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] p-8 text-center">
    <div class="relative flex items-center justify-center">
      <div
        class="absolute w-32 h-32 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 opacity-20 blur-2xl animate-pulse"
      />
      <span class="text-5xl font-bold leading-none text-base-content/90">404</span>
    </div>

    <h1 class="text-2xl font-bold my-2">{{ $t("common.notFound.title") }}</h1>

    <p class="max-w-[400px] mt-2 mb-6 text-base-content/70">{{ $t("common.notFound.description") }}</p>

    <router-link :to="{ name: 'dashboard.home' }" class="btn btn-primary min-w-[280px] py-3.5 px-8">
      {{ $t("common.notFound.goToHomepage") }}
    </router-link>

    <p class="text-sm mt-8 text-base-content/50">{{ $t("common.notFound.supportText") }}</p>
  </div>
</template>
